/* eslint-disable no-nested-ternary */
import React from 'react';

import { FormItem } from '@components/Forms/FormItem';
import { makeFormItemProps, BaseInputProps, extractOwnProps } from '@components/Forms/helpers';
import { TextBox, TextBoxProps } from '@components/TextBox';
import { useField } from 'formik';

export type TextInputProps = Omit<TextBoxProps, 'label'> &
  BaseInputProps & {
    tips?: string;
    fillOnFocus?: string;
  };

export const TextInput: React.FC<TextInputProps> = (props) => {
  const { onBlur, onValueChange, fillOnFocus, ...rest } = props;

  const { name, readOnly } = props;

  const [field, meta, helpers] = useField<string | boolean | number>(name);

  const hasError = !!(meta.touched && meta.error);

  const finalField: typeof field = {
    ...field,
    onBlur: (e: any) => {
      onBlur?.(e);
      field.onBlur(e);
    },
    onChange: (e: any) => {
      onValueChange?.(e.target.value);
      field.onChange(e);
    },
  };

  const setValue: typeof helpers.setValue = (v) => {
    onValueChange?.(v);
    helpers.setValue(v);
  };

  return (
    <FormItem {...makeFormItemProps(props)}>
      <TextBox
        setValue={setValue}
        hasError={hasError}
        {...finalField}
        {...(extractOwnProps(rest) as any)}
        {...(fillOnFocus && {
          onClick: () => {
            if (String(field.value).trim() === '') {
              setValue(fillOnFocus);
            }
          },
        })}
        setTouched={() => {
          helpers.setTouched(true);
        }}
        readOnly={readOnly}
      />
    </FormItem>
  );
};
